import type { EntityType } from "@config";
import { mapSettingsStrings } from "./wrap-tokens";

// Double or triple braces; first whitespace-delimited word is the token name.
const TOKEN_SOURCE = "\\{\\{\\{?\\s*([^{}\\s]+)[^{}]*\\}?\\}\\}";

const collectFromString = (str: string, out: Set<string>): void => {
  const re = new RegExp(TOKEN_SOURCE, "g");
  let m: RegExpExecArray | null;
  while ((m = re.exec(str)) !== null) {
    out.add(m[1].split(/\s+/)[0]);
  }
};

const collectFromEntity = (entity: EntityType, out: Set<string>): void => {
  mapSettingsStrings(entity.settings ?? {}, (str) => {
    collectFromString(str, out);
    return str;
  });
};

export interface SubtreeTokenScan {
  /** All token names found anywhere in the subtree. */
  inside: string[];
  /** Subset of `inside` that also appears in entities outside the subtree. */
  alsoOutside: string[];
}

export const scanSubtreeTokens = (
  subtreeEntities: Record<string, EntityType>,
  allEntities: Record<string, EntityType>,
): SubtreeTokenScan => {
  const inside = new Set<string>();
  for (const e of Object.values(subtreeEntities)) collectFromEntity(e, inside);

  const outside = new Set<string>();
  for (const [id, e] of Object.entries(allEntities)) {
    if (subtreeEntities[id]) continue;
    collectFromEntity(e, outside);
  }

  const insideArr = [...inside];
  return {
    inside: insideArr,
    alsoOutside: insideArr.filter((name) => outside.has(name)),
  };
};
